import { useEffect } from "react";
import {
  CalendarBlank,
  CheckCircle,
  RocketLaunch,
  Target,
  Eye,
  
} from "@phosphor-icons/react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import HrPromoSection from "../components/HrPromoSection";

const launchDate = "March 2, 2026";
const launchProductName = "Visaro Pay / Fly Now, Pay Later";

// const organogramUnits = [
//   {
//     team: "Product and Engineering",
//     role: "Build and scale Visaro Pay, platform APIs, and integration services.",
//   },
//   {
//     team: "Partnerships and Growth",
//     role: "Drive ecosystem partnerships with payment, credit, and verification providers.",
//   },
//   {
//     team: "Risk, Compliance and Verification",
//     role: "Manage KYC, AML, fraud controls, and regulatory alignment across operations.",
//   },
//   {
//     team: "Operations and Customer Success",
//     role: "Deliver onboarding, service reliability, and merchant/customer support.",
//   },
// ];

const visaroPayHighlights = [
  "Book flights instantly and spread payments with Fly Now, Pay Later flexibility.",
  
  
];

const rolloutItems = [
  {
    name: "HR BNPL Payroll System",
    status: "Coming Soon",
    detail:
      "A payroll-linked BNPL model that gives employees controlled flexibility while supporting employer cash-flow stability.",
  },
  {
    name: "Education BNPL & Learning Management System (LMS)",
    status: "Coming Soon",
    detail:
      "A financing and learning stack designed to make tuition and training programs more accessible through structured payments.",
  },
  {
    name: "Visaro Web Platform & Digital Marketplace",
    status: "Coming Soon",
    detail:
      "A unified experience for services, payments, and commerce where users can discover, pay, and transact in one place.",
  },
  {
    name: "Digital Identity & Biometric Verification Services",
    status: "Coming Soon",
    detail:
      "Secure customer onboarding and identity checks with biometrics, verification workflows, and compliance-ready controls.",
  },
];

const partners = [
  {
    name: "CREDICORP",
    logo: require("../assets/images/creditcorp-logo.webp"),
    description:
      "CREDICORP makes it easier for every Nigerian to access responsible credit, empowering users to do more, achieve more, and build lasting financial confidence.",
  },
  {
    name: "Alert Microfinance Bank",
    logo: require("../assets/images/alert-mfb-grouplogo.png"),
    description:
      "Alert Microfinance Bank is a trusted financial institution dedicated to empowering individuals and small businesses with easy access to quick, secure, and flexible financial solutions.",
  },
  {
    name: "youverify",
    logo: require("../assets/images/youverify.svg"),
    description:
      "uverify is a digital verification platform that provides a comprehensive suite of verification services to help businesses verify and authenticate customers' identities.",
  },
  {
    name: "Onafriq",
    logo: require("../assets/images/onafriq-logo-black.webp"),
    description:
      "Onafriq is a pan-African payments company which enables interoperable cross-border and domestic digital payments.",
  },
];

const About = () => {
  useEffect(() => {
    const hashId = window.location.hash.replace("#", "");

    if (hashId) {
      setTimeout(() => {
        const section = document.getElementById(hashId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, 80);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="bg-gray-50 text-gray-800">
      <Navbar />

      <section className="px-6 py-16 md:px-16 lg:px-24 bg-gradient-to-b from-visaro-orange-15 via-white to-gray-50">
        <div className="max-w-6xl mx-auto flex flex-col gap-10">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-visaro-orange/30 bg-visaro-orange/10 px-4 py-2 text-sm font-semibold text-visaro-orange">
            <CalendarBlank size={18} weight="duotone" />
            Launching {launchDate}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-start">
            <div className="flex flex-col gap-6">
              <h1 className="text-4xl md:text-6xl font-bold leading-tight text-deepBlue">
                Building a trusted digital finance ecosystem for Africa.
              </h1>
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                Visaro connects payments, identity, and strategic partnerships in
                one secure platform. We are launching with{" "}
                <span className="font-semibold text-deepBlue">
                  {launchProductName}
                </span>{" "}
                on{" "}
                <span className="font-semibold text-deepBlue">{launchDate}</span>,
                while additional partner-powered services continue rollout.
              </p>
            </div>

            <div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6 md:p-8 flex flex-col gap-5">
              <div className="flex items-center gap-3 text-deepBlue">
                <RocketLaunch size={24} weight="duotone" />
                <h2 className="text-2xl font-bold">Launch Snapshot</h2>
              </div>
              <p className="text-gray-600">
                {launchProductName} goes live on {launchDate}. The remaining
                platform modules are in active development and clearly marked as
                coming soon.
              </p>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="rounded-xl bg-deepBlue text-white p-4">
                  <div className="font-semibold">Primary Release</div>
                  <div className="text-white/90 mt-1">{launchProductName}</div>
                </div>
                <div className="rounded-xl bg-gray-100 p-4">
                  <div className="font-semibold text-deepBlue">Status</div>
                  <div className="text-gray-600 mt-1">March 2, 2026</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HrPromoSection />

      <section className="px-6 md:px-16 lg:px-24 py-8">
        <div className="max-w-6xl mx-auto flex flex-wrap gap-3">
          <a
            href="#mission"
            className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-deepBlue hover:border-deepBlue transition-colors"
          >
            Our Mission
          </a>
          <a
            href="#vision"
            className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-deepBlue hover:border-deepBlue transition-colors"
          >
            Our Vision
          </a>
          {/* <a
            href="#organogram"
            className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-deepBlue hover:border-deepBlue transition-colors"
          >
            Organogram
          </a> */}
          <a
            href="#partners"
            className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-deepBlue hover:border-deepBlue transition-colors"
          >
            Partners
          </a>
        </div>
      </section>

      <section className="px-6 pb-16 md:px-16 lg:px-24">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
          <article
            id="mission"
            className="rounded-3xl border border-gray-200 bg-white p-7 md:p-9 shadow-sm"
          >
            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-deepBlue text-white">
              <Target size={24} weight="duotone" />
            </div>
            <h2 className="text-3xl font-bold text-deepBlue mb-3">Our Mission</h2>
            <p className="text-gray-600 leading-relaxed">
              To empower individuals and businesses with secure, inclusive, and
              innovative digital financial services that increase access to
              payments, responsible credit, and trusted identity verification.
            </p>
          </article>

          <article
            id="vision"
            className="rounded-3xl border border-gray-200 bg-white p-7 md:p-9 shadow-sm"
          >
            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-visaro-orange text-white">
              <Eye size={24} weight="duotone" />
            </div>
            <h2 className="text-3xl font-bold text-deepBlue mb-3">Our Vision</h2>
            <p className="text-gray-600 leading-relaxed">
              To become Africa's most trusted ecosystem for interoperable
              payments, digital verification, and financial empowerment at scale.
            </p>
          </article>
        </div>
      </section>

      {/* <section id="organogram" className="px-6 py-16 md:px-16 lg:px-24 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-3xl mb-10">
            <h2 className="text-4xl md:text-5xl font-bold text-deepBlue">
              Organogram
            </h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              Our structure is designed for fast execution, regulatory discipline,
              and strong partner collaboration as we scale across the continent.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl bg-deepBlue text-white p-6 text-center">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white/15 mb-3">
                <Buildings size={24} weight="duotone" />
              </div>
              <h3 className="text-2xl font-bold">Board and Executive Office</h3>
              <p className="text-white/90 mt-2">
                Strategic direction, governance, and platform-wide accountability.
              </p>
            </div>

            <div className="mx-auto h-9 w-0.5 bg-gray-300" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {organogramUnits.map((unit) => (
                <article
                  key={unit.team}
                  className="rounded-2xl border border-gray-200 p-5 bg-gray-50"
                >
                  <h4 className="text-xl font-bold text-deepBlue">{unit.team}</h4>
                  <p className="text-gray-600 mt-2">{unit.role}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <section className="px-6 py-16 md:px-16 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-3xl">
            <h2 className="text-4xl md:text-5xl font-bold text-deepBlue">
              Product Rollout
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              {launchProductName} launches first on {launchDate}. The remaining
              platform modules below are currently marked as coming soon.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
            <article className="lg:col-span-2 rounded-3xl border border-deepBlue/20 bg-deepBlue text-white p-7 md:p-9">
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="text-3xl font-bold">{launchProductName}</h3>
                <span className="rounded-full bg-visaro-orange px-3 py-1 text-sm font-semibold">
                  Launching {launchDate}
                </span>
              </div>
              <p className="mt-4 text-white/90">
                {launchProductName} is the first major release on the platform,
                giving travelers, users, and merchants a reliable digital
                payment experience with modern security and financing
                flexibility.
              </p>

              <div className="mt-6 space-y-3">
                {visaroPayHighlights.map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <CheckCircle
                      size={20}
                      weight="fill"
                      className="text-visaro-orange mt-0.5 shrink-0"
                    />
                    <p className="text-white/95">{item}</p>
                  </div>
                ))}
              </div>
            </article>

            <div className="space-y-4">
              {rolloutItems.map((item) => (
                <article
                  key={item.name}
                  className="rounded-2xl border border-gray-200 bg-white p-5"
                >
                  <div className="flex items-center justify-between gap-3">
                    <h4 className="font-bold text-deepBlue">{item.name}</h4>
                    <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
                      {item.status}
                    </span>
                  </div>
                  
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="partners" className="px-6 py-16 md:px-16 lg:px-24 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-3xl">
            <h2 className="text-4xl md:text-5xl font-bold text-deepBlue">
              Strategic Partners
            </h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              These partners strengthen Visaro's ability to deliver secure
              payments, responsible credit, robust verification, and pan-African
              interoperability.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
            {partners.map((partner) => (
              <article
                key={partner.name}
                className="rounded-3xl border border-gray-200 bg-gray-50 p-6"
              >
                <div
                  className={`rounded-2xl p-4 border border-gray-100 ${
                    partner.name === "uverify" ? "bg-deepBlue" : "bg-white"
                  }`}
                >
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="h-10 w-full object-contain object-left"
                  />
                </div>
                <h3 className="mt-5 text-2xl font-bold text-deepBlue">
                  {partner.name}
                </h3>
                <p className="mt-3 text-gray-600 leading-relaxed">
                  {partner.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
